import React, {useState, useEffect} from 'react';
import axios from 'axios';

const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
const EPISODE_INTERVAL = 3; // days

function Episode() {
  const [randomLinks, setRandomLinks] = useState([]);
  const [recentLinks, setRecentLinks] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    axios
      .get('/api/v1/episode')
      .then((response) => {
        setRandomLinks(JSON.parse(response.data.randomList));
        if (response.data.recentList) {
          setRecentLinks(JSON.parse(response.data.recentList));
        }
      })
      .catch((error) => {
        setErrorMessage(error.message ? error.message : 'Failed to fetch data from server.');
      });
  }, []);

  const randomLinksJsx =
    randomLinks.length === 0 ? (
      errorMessage != null ? (
        <div>Encountered an error: {errorMessage}.</div>
      ) : (
        'Loading...'
      )
    ) : (
      <div>
        <ul>
          {randomLinks.map((link) => (
            <li key={link.id}>
              <span className="content">
                <a href={link.uri}>{link.title}</a>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );

  const recentLinksJsx =
    recentLinks.length === 0 ? (
      errorMessage != null ? (
        <div>Encountered an error: {errorMessage}.</div>
      ) : null
    ) : (
      // 'Loading...'
      <div>
        <ul>
          {recentLinks.map((link) => (
            <li key={link.id}>
              <span className="content">
                <a href={link.uri}>{link.title}</a>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );

  return (
    <div>
      <h3>episode of {getEpisodeDate()}</h3>
      <h4>random</h4>
      {randomLinksJsx}
      {recentLinksJsx ? (
        <div>
          <h4>recent</h4>
          {recentLinksJsx}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}

/**
 * Bumped every three days.
 */
function getEpisodeDate() {
  const episodeNumber = Math.floor(new Date().getTime() / MILLISECONDS_IN_A_DAY / EPISODE_INTERVAL);
  const date = new Date(episodeNumber * EPISODE_INTERVAL * MILLISECONDS_IN_A_DAY);
  return date.toISOString().slice(0, 10);
}

export default Episode;
